export default "__VITE_PUBLIC_ASSET__1a33d89c__"